import { createFileRoute, redirect } from "@tanstack/react-router";

// /tools moved to the /font-generator hub. Permanent redirect preserves link equity.
export const Route = createFileRoute("/tools/")({
  beforeLoad: () => {
    throw redirect({ to: "/font-generator", statusCode: 301 });
  },
});
